import { render } from "./GrButton.vue?vue&type=template&id=16fca7cc"
const script = {}

import "./GrButton.vue?vue&type=style&index=0&id=16fca7cc&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__